export const weekDays = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
export const months =  ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

/**
 *
 * @param y - year eg 2019
 * @param m - month 1-12
 * @param d - month day - 1-31
 * @returns {number} 0-6 where 0 is Sunday
 */
export function dayOfWeek(y, m, d) {
  return new Date(`${y}-${('0' + m).slice(-2)}-${('0' + d).slice(-2)}T00:00:00`).getDay();
}

export function getMonthLength(year, month) {
  let monthLength = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][month-1];
  if (month === 2) {
    if((year % 4 === 0 && year % 100 !== 0) || year % 400 === 0){
      monthLength = 29;
    }
  }
  return monthLength;
}

export function getMonthData(year, month) {

  const monthLength = getMonthLength(year, month);
  const startingDay = dayOfWeek(year, month, 1);
  let day = 1;
  let rows = [];

  for (let i = 0; i < 9; i++) {
    let cols = [];
    for (let j = 0; j <= 6; j++) {
      if (day <= monthLength && (i > 0 || j >= startingDay)) {
        cols.push(day);
        day++;
      }
      else {
        cols.push('');
      }
    }
    if (day > monthLength) {
      rows.push(cols);
      break;
    } else {
      rows.push(cols);
    }
  }

  return rows;
}

export function prettyDate(date) {
  return new Intl.DateTimeFormat('EN-us', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour:'numeric', minute:'numeric' }).format(date)
}
